import { useEffect, useRef } from 'react'
import { IChatOption, IMessage } from '../../../../shared/models/chat_models'
import MessageBubble from '../MessageBubble/MessageBubble'
import './ChatWindow.scss'
import ChatLoader from '../ChatLoader/ChatLoader'


interface IChatWindowProps {
    messages: Array<IMessage>
    loading: boolean
    chatOptions: Array<IChatOption>
}

const ChatWindow = (props: IChatWindowProps) => {

    const scrollRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (scrollRef.current) {
          scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
      }, [props.messages])

    return (
        <div 
            ref={scrollRef} 
            className='chat-window-wrapper'
        >
            {props.messages.map((message, index) => {
                return (
                    <div key={index} className='message-wrapper'>
                        <MessageBubble 
                            message={message.content} 
                            sender={message.role}
                            chatOptions={props.chatOptions}
                        />
                    </div>
                )
            })}
            {props.loading && 
                <div>
                    <ChatLoader />
                </div>
            }
        </div>
    )
}


export default ChatWindow